import script from "./config-calling-row.vue?vue&type=script&lang=jsx"
export * from "./config-calling-row.vue?vue&type=script&lang=jsx"

import "./config-calling-row.vue?vue&type=style&index=0&id=0e66f677&lang=scss"

const __exports__ = script;

export default __exports__